import { MediaContext } from 'react-media-query-hoc';
var ScreenContext = MediaContext;
export default ScreenContext;
